module.exports = __webpack_public_path__ + "media/custom/images/img39-67731e962252b08ec9e1b380abef33a7.jpg";